module.exports = __webpack_public_path__ + "static/img/yy16.a3a4499.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy16.png
// module id = Bvq9
// module chunks = 1